import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import {
  useAddServiceMutation,
  useUpdateServiceMutation,
} from "../../Data/services/serviceApi";
import { useUploadAttachmentMutation } from "../../Data/services/uploadAttachmentApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import {
  useAddCategoryMutation,
  useUpdateCategoryMutation,
} from "../../Data/services/categoryApi";
import ClipLoader from "react-spinners/ClipLoader";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import { CATEGORY_TYPE } from "../../Helper";

const EditCategoriesModal = ({ handleEditModalClose, editData, refetch }) => {
  const [rowId, setRowId] = useState("");
  const [category, setCategory] = useState("");
  // const [imageUrl, setImageUrl] = useState("");
  // const [imageFile, setImageFile] = useState("");
  // const [imagePreview, setImagePreview] = useState("");
  const [sending, setSending] = useState(false);

  const [selectedType, setSelectedType] = useState("");
  const typeList = Object.entries(CATEGORY_TYPE).map(([key, value]) => ({
    label: key,
    value: value,
  }));

  const handleTypeChange = (value) => {
    console.log(value);
    setSelectedType(value);
  };

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      console.log(editData);
      setRowId(editData.id);
      setCategory(editData.name);
      // setSelectedType(editData.type);
      // setImagePreview(editData.image_url || "");
      // setImageUrl(editData.image_url || "");
    }
  }, [editData, mounted]);

  const handleCategoryChange = (lang) => (e) => {
    setCategory(e.target.value);
  };

  // const [uploadAttachment, { isLoading: isUploading }] =
  //   useUploadAttachmentMutation();

  // const handleImagePreview = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;
  //   if (file) {
  //     setImageFile(file);
  //     setImagePreview(URL.createObjectURL(file));
  //   }
  // };

  // const handleImageUpload = async (e) => {
  //   const formData = new FormData();
  //   formData.append("file", imageFile);
  //   formData.append("path", "admin");

  //   // Loop through formData
  //   for (let [key, value] of formData.entries()) {
  //     console.log(key, value);
  //   }

  //   try {
  //     const response = await uploadAttachment({ formData }).unwrap();
  //     console.log(response);
  //     return response.data[0];
  //   } catch (error) {
  //     Toast("Failed to upload image", "error");
  //   }
  // };

  const [addCategory, { isLoading: adding }] = useAddCategoryMutation();
  const [updateCategory, { isLoading: updating }] = useUpdateCategoryMutation();

  const handleSubmit = async () => {
    console.log(rowId);
    // console.log(category);
    // console.log(imageUrl);

    if (!category) {
      Toast("All fields required.", "error");
      return;
    }

    setSending(true);
    try {
      // let imageName;
      // if (imageFile) {
      //   imageName = await handleImageUpload();
      // }

      const data = {
        name: category,
        // type: selectedType,
        // image_url: imageName || imageUrl || "", // already uploaded image URL
      };

      let response;
      if (editData) {
        response = await updateCategory({ data, id: rowId }).unwrap();
      } else {
        response = await addCategory(data).unwrap();
      }

      console.log(response);

      if (response.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.message);
        handleEditModalClose();
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 ">
              {editData ? "Edit" : "Add Category"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Enter category name"
                  value={category}
                  onChange={handleCategoryChange("en")}
                />
              </Col>
            </Row>

            {/* <Row>
              <Col md={12}>
                <SelectFieldComponent
                  firstOption={selectedType ? selectedType : "Select Type"}
                  optionsList={typeList}
                  onSelectChange={handleTypeChange}
                />
              </Col>
            </Row> */}

            {/* <Row>
              <Col md={9}>
                <Input
                  classes="mt-2 mb-3"
                  type="file"
                  placeholder="Image"
                  onChange={(e) => {
                    // handleImageUpload(e);
                    handleImagePreview(e);
                  }}
                />
              </Col>

              <Col md={3}>
                {isUploading ? (
                  <Spinner />
                ) : (
                  <img
                    src={
                      imagePreview || imageUrl || "https://placehold.co/100x100"
                    }
                    alt="category_image"
                    width={100}
                    height={100}
                    className="rounded"
                  />
                )}
              </Col>
            </Row> */}

            <Row>
              <Col md={12}>
                <Button
                  classes={`mt-3 mb-2 ${
                    sending || category.length <= 3
                      ? "bg-dark-subtle"
                      : "shadow"
                  } `}
                  text={
                    sending ? (
                      <ClipLoader color="#0f0f0f" size="22px" />
                    ) : editData ? (
                      "Update"
                    ) : (
                      "Save"
                    )
                  }
                  disabled={sending || category.length <= 3}
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditCategoriesModal;
